import React, {useState} from "react";
import icon1 from "./assets/acou.png";
import icon2 from "./assets/dripGold.png";
const ChooseNFTCard = ({
  className,
  imgClassName,
  imgWrapClassName,
  thum,
  gold,
  setSelectedNft,
}) => {
  return (
    <div>
      <div
        className={`w-full md:w-[256px] group  flex-none rounded-[15px] pb-[11px] bg-main-black ${className}`}
      >
        <div
          className={`lg:max-h-[319px] p-[15px] pb-[18px] relative ${imgWrapClassName}`}
        >
          <img
            className={`w-full md:w-[290px]  mx-auto rounded-[15px] ${imgClassName}`}
            src={thum}
            alt=""
          />
          <div className="absolute inset-0 flex justify-center items-center">
            <button
              onClick={() => setSelectedNft("selected")}
              className="group-hover:block md:hidden w-[130px] bg-white rounded-[20px]  hover:opacity-100 hover:bg-slate-200 font-bold h-[40px] text-res-ls text-[#0E0E0E]"
            >
              Select
            </button>
          </div>
        </div>
        <div className="px-[20px] ">
          <div className=" flex justify-between ">
            <div>
              <div className="text-res-xxs font-bold ">
                R34P{" "}
                {gold ? (
                  <span className="text-[#FFB800]">Gold</span>
                ) : (
                  "Platinum"
                )}{" "}
              </div>
              <div className="flex items-start gap-[1px] mt-[2px] pb-[2px]">
                <img className="w-[31px]" src={icon2} alt="" />
                <img className="w-[33px]" src={icon1} alt="" />
              </div>
              <h4 className="text-[10px] text-[#8A8AA0] leading-[15px]">
                Owned By{" "}
                <span className="text-[12px] text-[#EBEBEB] leading-[22px]">
                  0x736f...6245a9
                </span>
              </h4>
            </div>
            <div className=" flex flex-col items-end">
              <button className=" w-[38px] h-[18px] rounded-[7px] bg-main-green text-main-black font-bold text-[9px] leading-[15px]">
                ETH
              </button>
              <div className="flex flex-col items-end mt-[20px]">
                <h1 className="text-[#8A8AA0] text-[13px] leading-[20px] mb-[2px]">
                  Price
                </h1>
                <h3 className="text-res-xxs font-bold">4.89 ETH</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseNFTCard;
